import { render } from "./setpt.vue?vue&type=template&id=a4da9a46"
import script from "./setpt.vue?vue&type=script&lang=js"
export * from "./setpt.vue?vue&type=script&lang=js"

import "./setpt.vue?vue&type=style&index=0&id=a4da9a46&lang=scss"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__